/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Button, Row, Col } from "reactstrap";
import moment from "moment";

import {
  getMultipleClientsReport,
  exportMultipleClientReportPdf,
  exportMultipleClientReportHtml,
  clearMultipleClientsReportHtml,
  clearMultipleClientsReports,
  clearMultipleClientsReportPdf,
} from "../../actions";

// import { createAsyncJob } from "../../../organization/actions";

import {
  multipleClientsReportSelector,
  multipleClientReportPdfSelector,
  multipleClientReportHtmlSelector,
  multipleClientReportPdfIsLoadingSelector,
  multipleClientReportHtmlIsLoadingSelector,
  multipleClientsReportFiltersSelector,
  isLoadingSelector,
} from "../../selectors";
import MultipleClientsFilter from "./multiple-clients-filter";
import MultipleClientsTable from "./multiple-clients-table";

import "./multipleClientsReportPage.css";
import HtmlIcon from "../../../../assets/HtmlIcon";
// import { Document2Icon } from "../../../../assets";
import Pdf2Icon from "../../../../assets/Pdf2Icon";
import { PageTitle } from "../../../../components/common";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";

const MultipleClientsReportPage = () => {
  const dispatch = useDispatch();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isOpenCollapse, setIsOpenCollapse] = useState(true);

  const multipleClientsReport = useSelector(multipleClientsReportSelector);
  const multipleClientsReportFilters = useSelector(
    multipleClientsReportFiltersSelector
  );
  const multipleClientReportPdf = useSelector(multipleClientReportPdfSelector);
  const multipleClientReportHtml = useSelector(
    multipleClientReportHtmlSelector
  );
  const isLoading = useSelector(multipleClientReportPdfIsLoadingSelector);
  const isLoadingHtml = useSelector(multipleClientReportHtmlIsLoadingSelector);
  const isSearching = useSelector(isLoadingSelector);
  const toggleCollapse = () => setIsOpenCollapse(!isOpenCollapse);
  const handleExportPdf = () => {
    dispatch(exportMultipleClientReportPdf(multipleClientsReportFilters));
  };

  const handleExportHtml = () => {
    dispatch(exportMultipleClientReportHtml(multipleClientsReportFilters));
  };
  // const handleCreateAsyncJob = () => {
  //   multipleClientsReportFilters.jobType = "MultipleClientsReport";
  //   dispatch(createAsyncJob(multipleClientsReportFilters));
  // };

  useEffect(() => {
    if (multipleClientReportHtml.size > 0) {
      const url = URL.createObjectURL(multipleClientReportHtml);
      const link = document.createElement("a");
      link.href = url;
      link.download = `multiple-client-report-${moment
        .utc()
        .local()
        .format("DD-MM-YYYY-HHmm")}.html`;
      link.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(url);
      }, 100);
      dispatch(clearMultipleClientsReportHtml());
    }
  }, [multipleClientReportHtml]);

  useEffect(() => {
    if (multipleClientReportPdf.size > 0) {
      const url = URL.createObjectURL(multipleClientReportPdf);

      const link = document.createElement("a");
      link.href = url;
      link.download = `multiple-client-report-${moment
        .utc()
        .local()
        .format("DD-MM-YYYY-HHmm")}.pdf`;
      link.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(url);
      }, 100);
      dispatch(clearMultipleClientsReportPdf());

      // window.location.href(url, '_blank');
    }
  }, [multipleClientReportPdf]);

  useEffect(() => {
    if (isSubmitted) {
      dispatch(getMultipleClientsReport());
      setIsSubmitted(false);
    }
  });

  useEffect(() => {
    return () => {
      dispatch(clearMultipleClientsReports());
    };
  }, []);

  return (
    <Container
      className="multiple-clients-report-page-container p-0 col-12"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          document
            .getElementById("getMultipleClientsReportSubmitButton")
            .click();
        }
      }}
    >
      <PageTitle title="multiple clients report" />
      <FullscreenLoader loading={isLoading || isLoadingHtml || isSearching} />

      <MultipleClientsFilter
        setIsSubmitted={setIsSubmitted}
        isOpenCollapse={isOpenCollapse}
        toggleCollapse={toggleCollapse}
        multipleClientsReport={multipleClientsReport}
      />
      {multipleClientsReport.createdBy ? null : (
        <div className="multiple-clients-background-logo" />
      )}
      {multipleClientsReport.createdBy && (
        <React.Fragment>
          <Container className="mt-5">
            <Row>
              <Col lg={6}>
                <Button
                  color="primary"
                  onClick={() => handleExportPdf()}
                  className="float-left export-button-multiple-clients"
                  disabled={isLoading}
                >
                  <Pdf2Icon />
                  Download as PDF
                </Button>
              </Col>
              <Col lg={6} className="float-right ">
                <Button
                  color="primary"
                  onClick={() => handleExportHtml()}
                  className="float-right export-button-multiple-clients"
                  disabled={isLoadingHtml}
                >
                  <HtmlIcon />
                  Download as HTML
                </Button>
              </Col>
            </Row>
            <br />
            <Row>
              {/* <Col lg={6}>
                <Button
                  color="primary"
                  onClick={() => handleCreateAsyncJob()}
                  disabled={isLoadingHtml}
                  className="float-left export-button-multiple-clients"
                >
                  <Document2Icon />
                  Create Multiclientreport as Parallel Job
                </Button>
              </Col> */}
            </Row>
            <Row>
              <MultipleClientsTable
                multipleClientsReport={multipleClientsReport}
              />
            </Row>
          </Container>
        </React.Fragment>
      )}
    </Container>
  );
};

export default MultipleClientsReportPage;



// WEBPACK FOOTER //
// ./src/features/reports/pages/multiple-clients-report/MultipleClientsReportPage.jsx